/**
 * Created by Jerker Nord on 2024-06-03.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVFastWinWaysContainer} from "../../components/BenjiKIVFastWinWaysContainer";
import {gsap} from "gsap";
import {BetWayWins} from "../../server/BenjiKIVData";
import {BenjiKIVSymbol} from "../../reels/BenjiKIVSymbol";
import {BenjiKIVSymbolStates} from "../../../core/reel/ReelInterfaces";
import {BenjiKIVStatics} from "../../BenjiKIVStatics";

export class BenjiKIVFastToggleWinWaysView extends PIXI.Container implements StageLayer {

    constructor() {
        super();
        this.name = "BenjiKIVFastToggleWinWaysView";
        this.visible = false;
    }

    public getAllWinWaysAnimation():gsap.core.Timeline {
        const allWinWaysTL:gsap.core.Timeline = gsap.timeline();
        const betWayWins:BetWayWins[] = BenjiKIV.model.betWayWins;
        let targetReel:number = 0;
        let targetRow:number = 3;

        allWinWaysTL.add(() => {
            this.visible = true;
        });
        for(let i:number = 0; i < betWayWins.length; i++) {
            const showComboTL:gsap.core.Timeline = gsap.timeline();
            const setAllSymbolsTLs:gsap.core.Timeline[] = [];
            let waysContainer:BenjiKIVFastWinWaysContainer = BenjiKIV.fastWinWaysPool.getWinWaysContainer(betWayWins[i].multipliedAmount, betWayWins[i].numberOfCombinations);
            showComboTL.add(() => {
                targetReel = 0;
                targetRow = 3;
                for(let j:number = 0; j < betWayWins[i].winPositions.length; j++) {
                    for(let k:number = 0; k < betWayWins[i].winPositions[j].length; k++) {
                        let symbol:BenjiKIVSymbol = (<BenjiKIVSymbol>BenjiKIV.allReelView.reelModels[j].reelView.symbols[k + 3]);
                        if(k == 0 && symbol.stackedSymbolName.indexOf("BOT") > -1) {
                            symbol = (<BenjiKIVSymbol>BenjiKIV.allReelView.reelModels[j].reelView.symbols[k + 2]);
                        }
                        if(k == 2 && symbol.stackedSymbolName.indexOf("TOP") > -1) {
                            symbol = (<BenjiKIVSymbol>BenjiKIV.allReelView.reelModels[j].reelView.symbols[k + 3]);
                        }
                        if(betWayWins[i].winPositions[j][k] == false) {
                            setAllSymbolsTLs.push(symbol.getNewStateAnimation(BenjiKIVSymbolStates.NO_WIN, 0.001));
                        } else {
                            if(j > targetReel) {
                                targetReel = j;
                                targetRow = k;
                            }
                            if(k < targetRow) {
                                targetRow = k;
                            }
                            if (symbol.splitLevel > 1){
                                setAllSymbolsTLs.push(symbol.getNewStateAnimation(BenjiKIVSymbolStates.SPLIT, 0.001));
                            }else{
                                setAllSymbolsTLs.push(symbol.getNewStateAnimation(BenjiKIVSymbolStates.NORMAL, 0.001));
                            }
                        }
                    }
                }
            });
            showComboTL.add(setAllSymbolsTLs);
            showComboTL.add(() => {
                waysContainer.position.set((targetReel * BenjiKIVStatics.symbolWidth), ((targetRow + 2) * BenjiKIVStatics.symbolHeight));
                this.addChild(waysContainer);
            });
            showComboTL.add(waysContainer.getShowTL());
            showComboTL.add(() => {this.removeChild(waysContainer)});
            allWinWaysTL.add(showComboTL);
        }

        allWinWaysTL.add(() => {
            BenjiKIV.fastWinWaysPool.resetAllUsed();
            this.removeChildren();
            this.visible = false;
        });


        return allWinWaysTL;
    }
}